import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import cookie from 'vue-cookie'
import 'v2-datepicker/lib/index.css'; // v2 need to improt css
import V2Datepicker from 'v2-datepicker';

Vue.config.productionTip = false
//Vue.use(VueAxios, axios)
Vue.prototype.$axios = axios
Vue.prototype.$cookie = cookie
Vue.use(V2Datepicker)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
